module.exports = __webpack_public_path__ + "img/que-title.2179e571.png";